import React, { useState } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  initialNote: string;
  onSave: (note: string) => void;
  onCancel: () => void;
};

const ContractingNoteSubDialog = ({ initialNote, onSave, onCancel }: Props) => {
  // translations
  const tLabels = useTranslation("contracting\\contracting").t;

  // state
  const [note, setNote] = useState<string>(initialNote ?? "");

  // render
  return (
    <div>
      <div className="form-group">
        <textarea
          className="form-control"
          rows={5}
          value={note}
          placeholder={tLabels("contractingAdminActions.notePlaceholder")}
          onChange={(e) => setNote(e.target.value)}
        />
      </div>
      <div className="text-right">
        <button className="btn btn-outline-secondary mr-2" onClick={onCancel}>
          {tLabels("contractingAdminActions.close")}
        </button>
        <button className="btn btn-primary" onClick={() => onSave(note)}>
          {tLabels("contractingAdminActions.save")}
        </button>
      </div>
    </div>
  );
};

export default ContractingNoteSubDialog;
